import React, {Component} from "react";
import '../../EMR.css';
import BorderedRadioEnumInput from "../../../../../components/radio-input/BorderedRadioEnumInput";
import TextInput from "../../../../../components/text-input/TextInput";
import Select from "react-select";
import PhysicalActivityEnum from "../enums/lifestyle/PhysicalActivityEnum";
import BorderedCheckboxInput from "../../../../../components/checkbox-input/BorderedCheckboxInput";
import PsychoSocialHistoryEnum from "../enums/lifestyle/PsychoSocialHistoryEnum";
import RedAsterisk from "../../../../../components/asterisk/RedAsterisk";
import {DateInput} from "../../../../../components";
import {connect} from "react-redux";
import BorderedRadioLookupInput from "../../../../../components/radio-input/BorderedRadioLookupInput";
import {FormField} from "../../../../../components/form";
import moment from "moment";

class LifestyleModal extends Component {

    state= {}

    constructor(props) {
        super(props);
        this.state.lifestyle = props.lifestyle;

        this.setDefaultValuesToLookups();
        // DateInput component stores dates as epoch millis
        this.state.lifestyle.drinkingStartDate = this.state.lifestyle.drinkingStartDate ?
            moment(this.state.lifestyle.drinkingStartDate).utc(true).toDate() : null
        this.state.lifestyle.drinkingStopDate = this.state.lifestyle.drinkingStopDate ?
            moment(this.state.lifestyle.drinkingStopDate).utc(true).toDate() : null
        this.state.lifestyle.smokingStartDate = this.state.lifestyle.smokingStartDate ?
            moment(this.state.lifestyle.smokingStartDate).utc(true).toDate() : null
        this.state.lifestyle.smokingStopDate = this.state.lifestyle.smokingStopDate ?
            moment(this.state.lifestyle.smokingStopDate).utc(true).toDate() : null
        this.state.lifestyle.substanceAbuseStartDate = this.state.lifestyle.substanceAbuseStartDate ?
            moment(this.state.lifestyle.substanceAbuseStartDate).utc(true).toDate() : null
        this.state.lifestyle.substanceAbuseStopDate = this.state.lifestyle.substanceAbuseStopDate ?
            moment(this.state.lifestyle.substanceAbuseStopDate).utc(true).toDate() : null
    }

    render() {
        // Clear form fields array to rebuild it with only visible fields
        this.props.formFields.length = 0;

        const valueLabelUntilTwenty = this.generateValueLabelArray(20);
        const valueLabelUntilTen = this.generateValueLabelArray(10);

        const drinkingStatusName = this.state.lifestyle.drinkingStatus?.name;
        const drinkingInfoDisabled = !drinkingStatusName || drinkingStatusName === "Unknown" || drinkingStatusName === "Never";
        
        const smokingStatusName = this.state.lifestyle.smokingStatus?.name;
        const smokingInfoDisabled = !smokingStatusName || smokingStatusName === "Unknown" || smokingStatusName === "Never";

        const substanceAbuseStatusName = this.state.lifestyle.substanceAbuseStatus?.name;
        const substanceAbuseInfoDisabled = !substanceAbuseStatusName || substanceAbuseStatusName === "Unknown" || substanceAbuseStatusName === "Never";

        return (<div className={"emr-background"}>
                <div className="content-label" style={{marginLeft: "40px"}}>Lifestyle <RedAsterisk renderForAll/></div>
                <div className={"emr-modal content-row"} style={{width: "100%"}}>
                    <div className={"content-col-6"}
                         style={{maxWidth: "42%",marginLeft:"0px", marginRight:"40px", marginTop:"0px"}}>
                        <div>
                            <div style={{
                                fontWeight: "bold",
                                fontSize: "14px",
                                marginBottom: "0.2rem"
                            }}>Alcohol <RedAsterisk renderForAll/></div>
                            <div className={"row no-margin"}>
                                <div>
                                    <FormField ref={field => this.props.formFields.push(field)}
                                               required validateOn={this.state.lifestyle.drinkingStatus}>
                                        <BorderedRadioLookupInput
                                            values={this.props.drinkingStatuses}
                                            selected={this.state.lifestyle.drinkingStatus}
                                            onSelect={(val) =>
                                                this.setState((state) => {
                                                    state.lifestyle.drinkingStatus = val
                                                    if (!val || val.name === "Unknown" || val.name === "Never") {
                                                        state.lifestyle.drinkingStartDate = null
                                                        state.lifestyle.drinkingStopDate = null
                                                        state.lifestyle.alcoholUnitsPerWeek = null
                                                    }
                                                    return state;
                                                })
                                            }
                                        />
                                    </FormField>
                                </div>
                                {!drinkingInfoDisabled && (
                                    <div className={"pl-3 col-8"}>
                                        <div className={"row"}>
                                            <div>
                                                Date Started
                                            </div>
                                            <div className={"pl-2 pr-4"}>
                                                <FormField ref={field => this.props.formFields.push(field)}
                                                           max={this.state.lifestyle.drinkingStopDate}
                                                           maxMessage={"Should be before stop date"}
                                                           required validateOn={this.state.lifestyle.drinkingStartDate}>
                                                    <DateInput className={"treatment-schedule-date"}
                                                               variant="dialog"
                                                               emptyLabel="Date..."
                                                               utcTime={false}
                                                               disableFuture={true}
                                                               value={this.state.lifestyle.drinkingStartDate ?
                                                                   this.state.lifestyle.drinkingStartDate : null}
                                                               onChange={val => this.setState((state) => {
                                                                   state.lifestyle.drinkingStartDate = val
                                                                   return state
                                                               })}
                                                    />
                                                </FormField>
                                            </div>
                                            <div>
                                                Date Stopped
                                            </div>
                                            <div className={"pl-2"}>
                                                <FormField ref={field => this.props.formFields.push(field)}
                                                           min={this.state.lifestyle.drinkingStartDate}
                                                           minMessage={"Should be after start date"}
                                                           validateOn={this.state.lifestyle.drinkingStopDate}>
                                                    <DateInput className={"treatment-schedule-date"}
                                                               variant="dialog"
                                                               emptyLabel="Date..."
                                                               utcTime={false}
                                                               disableFuture={true}
                                                               value={this.state.lifestyle.drinkingStopDate ?
                                                                   this.state.lifestyle.drinkingStopDate : null}
                                                               onChange={val => this.setState((state) => {
                                                                   state.lifestyle.drinkingStopDate = val
                                                                   return state
                                                               })}
                                                    />
                                                </FormField>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {!drinkingInfoDisabled && (
                                <div className={"row no-margin p-1"}>
                                    <div className={"col-3 no-padding"}
                                         style={{
                                             marginTop: "auto",
                                             marginBottom: "auto",
                                             fontWeight: "bold",
                                             fontSize: "11px"
                                         }}>
                                        Units Per Week
                                    </div>
                                    <div className={"col-4 no-padding"}>
                                        <FormField ref={field => this.props.formFields.push(field)}
                                                   validateOn={this.state.lifestyle.alcoholUnitsPerWeek}>
                                            <Select
                                                className={"emr-white-select-container"}
                                                classNamePrefix={"emr-white-select"}
                                                value={this.state.lifestyle.alcoholUnitsPerWeek != null ?
                                                    {
                                                        value: this.state.lifestyle.alcoholUnitsPerWeek,
                                                        label: this.state.lifestyle.alcoholUnitsPerWeek
                                                    } : null}
                                                onChange={(event) => {
                                                    let r = event.value;
                                                    this.setState((state) => {
                                                        state.lifestyle.alcoholUnitsPerWeek = r;
                                                        return state;
                                                    });
                                                }}
                                                options={valueLabelUntilTwenty}/>
                                        </FormField>
                                    </div>
                                </div>
                            )}

                            <TextInput value={this.state.lifestyle.alcoholDetail || ''}
                                       placeholder={"Details"}
                                       style={{width: '-webkit-fill-available'}}
                                       onChange={value => this.setState(state => {
                                           state.lifestyle.alcoholDetail = value;
                                           return state;
                                       })
                                       }
                            />
                        </div>

                        <br/>

                        <div>
                            <div style={{fontWeight: "bold", fontSize: "14px", marginBottom: "0.2rem"}}>Physical
                                Activity / Exercise <RedAsterisk renderForAll/></div>
                            <FormField ref={field => this.props.formFields.push(field)}
                                       required validateOn={this.state.lifestyle.physicalActivity}>
                                <BorderedRadioEnumInput
                                    values={PhysicalActivityEnum.toArray()}
                                    selected={this.state.lifestyle.physicalActivity}
                                    onSelect={(value) => {
                                        this.setState((state) => {
                                            state.lifestyle.physicalActivity = value;
                                            return state;
                                        })
                                    }}/>
                            </FormField>
                            <TextInput value={this.state.lifestyle.physicalActivityDetail || ''}
                                       placeholder={"Details"}
                                       style={{width: '-webkit-fill-available'}}
                                       onChange={value =>  this.setState(state => {
                                           state.lifestyle.physicalActivityDetail = value;
                                           return state;
                                       })
                                       }
                            />
                        </div>


                    </div>
                    <div className={"content-col-6"}
                         style={{maxWidth: "42%",marginLeft:"20px",marginRight:"0px", marginTop:"0px"}}>
                        <div>
                            <div style={{fontWeight: "bold", fontSize: "14px", marginBottom: "0.2rem"}}>Smoking
                                <RedAsterisk renderForAll/></div>
                            <div className={"row no-margin"}>
                                <div className={"col-7 no-padding"}>
                                    <FormField ref={field => this.props.formFields.push(field)}
                                               required validateOn={this.state.lifestyle.smokingStatus}>
                                        <BorderedRadioLookupInput
                                            values={this.props.smokingStatuses}
                                            selected={this.state.lifestyle.smokingStatus}
                                            onSelect={(val) => {
                                                this.setState((state) => {
                                                    state.lifestyle.smokingStatus = val
                                                    if (!val || val.name === "Unknown" || val.name === "Never") {
                                                        state.lifestyle.smokingStartDate = null
                                                        state.lifestyle.smokingStopDate = null
                                                        state.lifestyle.smokingPacksPerDay = null
                                                        state.lifestyle.smokingDevice = null
                                                    }
                                                    return state;
                                                })
                                            }}
                                        />
                                    </FormField>
                                </div>
                                {!smokingInfoDisabled && (
                                    <>
                                        <div className={"col-2 no-padding"}
                                             style={{
                                                 marginTop: "auto",
                                                 marginBottom: "auto",
                                                 fontWeight: "bold",
                                                 fontSize: "11px"
                                             }}>
                                            Smoking Device
                                        </div>
                                        <div className={"col-3 no-padding"}
                                             style={{
                                                 marginTop: "auto",
                                                 marginBottom: "auto"
                                             }}>
                                            <FormField ref={field => this.props.formFields.push(field)}
                                                       validateOn={this.state.lifestyle.smokingDevice}>
                                                <Select
                                                    className={"emr-white-select-container"}
                                                    classNamePrefix={"emr-white-select"}
                                                    placeholder={"Device"}
                                                    value={this.state.lifestyle.smokingDevice}
                                                    getOptionValue={v => v.id}
                                                    getOptionLabel={v => v.name}
                                                    onChange={(val) => {
                                                        this.setState((state) => {
                                                            state.lifestyle.smokingDevice = val;
                                                            return state;
                                                        });
                                                    }}
                                                    options={this.props.smokingDevices}
                                                />
                                            </FormField>
                                        </div>
                                    </>
                                )}
                            </div>

                            {!smokingInfoDisabled && (
                                <>
                                    <div className={"pl-3 pt-2 row"}>
                                        <div>
                                            Date Started
                                        </div>
                                        <div className={"pl-2 pr-4"}>
                                            <FormField ref={field => this.props.formFields.push(field)}
                                                       max={this.state.lifestyle.smokingStopDate}
                                                       maxMessage={"Should be before stop date"}
                                                       required validateOn={this.state.lifestyle.smokingStartDate}>
                                                <DateInput className={"treatment-schedule-date"}
                                                           variant="dialog"
                                                           emptyLabel="Date..."
                                                           utcTime={false}
                                                           disableFuture={true}
                                                           value={this.state.lifestyle.smokingStartDate ?
                                                               this.state.lifestyle.smokingStartDate : null}
                                                           onChange={val => this.setState((state) => {
                                                               state.lifestyle.smokingStartDate = val
                                                               return state
                                                           })}
                                                />
                                            </FormField>
                                        </div>

                                        <div>
                                            Date Stopped
                                        </div>
                                        <div className={"pl-2"}>
                                            <FormField ref={field => this.props.formFields.push(field)}
                                                       min={this.state.lifestyle.smokingStartDate}
                                                       minMessage={"Should be after start date"}
                                                       validateOn={this.state.lifestyle.smokingStopDate}>
                                                <DateInput className={"treatment-schedule-date"}
                                                           variant="dialog"
                                                           emptyLabel="Date..."
                                                           utcTime={false}
                                                           disableFuture={true}
                                                           value={this.state.lifestyle.smokingStopDate ?
                                                               this.state.lifestyle.smokingStopDate : null}
                                                           onChange={val => this.setState((state) => {
                                                               state.lifestyle.smokingStopDate = val
                                                               return state
                                                           })}
                                                />
                                            </FormField>
                                        </div>
                                    </div>

                                    <div className={"row no-margin p-1"}>
                                        <div className={"col-3 no-padding"}
                                             style={{
                                                 marginTop: "auto",
                                                 marginBottom: "auto",
                                                 fontWeight: "bold",
                                                 fontSize: "11px"
                                             }}>
                                            Packs Per Day
                                        </div>
                                        <div className={"col-4 no-padding"}>
                                            <FormField ref={field => this.props.formFields.push(field)}
                                                       validateOn={this.state.lifestyle.smokingPacksPerDay}>
                                                <Select
                                                    className={"emr-white-select-container"}
                                                    classNamePrefix={"emr-white-select"}
                                                    value={this.state.lifestyle.smokingPacksPerDay != null ?
                                                        {
                                                            value: this.state.lifestyle.smokingPacksPerDay,
                                                            label: this.state.lifestyle.smokingPacksPerDay
                                                        } : null}
                                                    onChange={(event) => {
                                                        let r = event.value;
                                                        this.setState((state) => {
                                                            state.lifestyle.smokingPacksPerDay = r;
                                                            return state;
                                                        });
                                                    }}
                                                    options={valueLabelUntilTen}/>
                                            </FormField>
                                        </div>
                                    </div>
                                </>
                            )}

                            <TextInput value={this.state.lifestyle.smokingDetail || ''}
                                       placeholder={"Details"}
                                       style={{width: '-webkit-fill-available'}}
                                       onChange={value => this.setState(state => {
                                           state.lifestyle.smokingDetail = value;
                                           return state;
                                       })
                                       }
                            />

                            <br/>

                            <div>
                                <div style={{fontWeight: "bold", fontSize: "14px", marginBottom: "0.2rem"}}>
                                    Substance Abuse <RedAsterisk renderForAll/>
                                </div>
                                <div className={"row no-margin"}>
                                    <div>
                                        <FormField ref={field => this.props.formFields.push(field)}
                                                   required validateOn={this.state.lifestyle.substanceAbuseStatus}>
                                            <BorderedRadioLookupInput
                                                values={this.props.substanceAbuseStatuses}
                                                selected={this.state.lifestyle.substanceAbuseStatus}
                                                onSelect={(val) =>
                                                    this.setState((state) => {
                                                        state.lifestyle.substanceAbuseStatus = val
                                                        if (!val || val.name === "Unknown" || val.name === "Never") {
                                                            state.lifestyle.substanceAbuseStartDate = null
                                                            state.lifestyle.substanceAbuseStopDate = null
                                                            state.lifestyle.substanceAbuse = null
                                                        }
                                                        return state;
                                                    })
                                                }
                                            />
                                        </FormField>
                                    </div>
                                    {!substanceAbuseInfoDisabled && (
                                        <div className={"pl-3 col-8"}>
                                            <div className={"row"}>
                                                <div>
                                                    Date Started
                                                </div>
                                                <div className={"pl-2 pr-4"}>
                                                    <FormField ref={field => this.props.formFields.push(field)}
                                                               max={this.state.lifestyle.substanceAbuseStopDate}
                                                               maxMessage={"Should be before stop date"}
                                                               required validateOn={this.state.lifestyle.substanceAbuseStartDate}>
                                                        <DateInput className={"treatment-schedule-date"}
                                                                   variant="dialog"
                                                                   emptyLabel="Date..."
                                                                   utcTime={false}
                                                                   disableFuture={true}
                                                                   value={this.state.lifestyle.substanceAbuseStartDate ?
                                                                       this.state.lifestyle.substanceAbuseStartDate : null}
                                                                   onChange={val => this.setState((state) => {
                                                                       state.lifestyle.substanceAbuseStartDate = val
                                                                       return state
                                                                   })}
                                                        />
                                                    </FormField>
                                                </div>
                                                <div>
                                                    Date Stopped
                                                </div>
                                                <div className={"pl-2"}>
                                                    <FormField ref={field => this.props.formFields.push(field)}
                                                               min={this.state.lifestyle.substanceAbuseStartDate}
                                                               minMessage={"Should be after start date"}
                                                               validateOn={this.state.lifestyle.substanceAbuseStopDate}>
                                                        <DateInput className={"treatment-schedule-date"}
                                                                   variant="dialog"
                                                                   emptyLabel="Date..."
                                                                   utcTime={false}
                                                                   disableFuture={true}
                                                                   value={this.state.lifestyle.substanceAbuseStopDate ?
                                                                       this.state.lifestyle.substanceAbuseStopDate : null}
                                                                   onChange={val => this.setState((state) => {
                                                                       state.lifestyle.substanceAbuseStopDate = val
                                                                       return state
                                                                   })}
                                                        />
                                                    </FormField>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {!substanceAbuseInfoDisabled && (
                                    <div className={"row no-margin p-1"}>
                                        <div className={"col-3 no-padding"}
                                             style={{
                                                 marginTop: "auto",
                                                 marginBottom: "auto",
                                                 fontWeight: "bold",
                                                 fontSize: "11px"
                                             }}>
                                            Substance Type
                                        </div>
                                        <div className={"col-4 no-padding"}>
                                            <FormField ref={field => this.props.formFields.push(field)}
                                                       validateOn={this.state.lifestyle.substanceAbuse}>
                                                <Select
                                                    className={"emr-white-select-container"}
                                                    classNamePrefix={"emr-white-select"}
                                                    placeholder={"Substance Type"}
                                                    value={this.state.lifestyle.substanceAbuse}
                                                    getOptionValue={v => v.id}
                                                    getOptionLabel={v => v.name}
                                                    onChange={(val) => {
                                                        this.setState((state) => {
                                                            state.lifestyle.substanceAbuse = val;
                                                            return state;
                                                        });
                                                    }}
                                                    options={this.props.substanceAbuseTypes}
                                                />
                                            </FormField>
                                        </div>
                                    </div>
                                )}

                                <TextInput value={this.state.lifestyle.substanceAbuseDetail || ''}
                                           placeholder={"Details"}
                                           style={{width: '-webkit-fill-available'}}
                                           onChange={value => this.setState(state => {
                                               state.lifestyle.substanceAbuseDetail = value;
                                               return state;
                                           })
                                           }
                                />
                            </div>
                        </div>

                        <br/>

                        <div>
                            <div style={{fontWeight: "bold", fontSize: "18px", marginBottom: "0.3rem"}}>Psycho - Social
                                History <RedAsterisk renderForAll/></div>
                            <FormField ref={field => this.props.formFields.push(field)}
                                       required validateOn={this.state.lifestyle.psychoSocialHistory}>
                                <BorderedCheckboxInput
                                    values={PsychoSocialHistoryEnum.toArray()}
                                    selected={this.state.lifestyle.psychoSocialHistory}/>
                            </FormField>
                            <TextInput value={this.state.lifestyle.psychoSocialHistoryDetail || ''}
                                       placeholder={"Details"}
                                       style={{width: '-webkit-fill-available'}}
                                       onChange={value => this.setState(state => {
                                           state.lifestyle.psychoSocialHistoryDetail = value;
                                           return state;
                                       })
                                       }
                            />
                        </div>
                    </div>
                </div>

            </div>
        );
    }

    generateValueLabelArray(arraySize) {
        const foo = new Array(arraySize);
        for (let i = 1; i <= arraySize; i++) {
            foo.push({value: i, label: i});
        }
        return foo;
    }

    setDefaultValuesToLookups() {
        if (!this.state.lifestyle.drinkingStatus) {
            const unknownDrinkingStatus = this.props.drinkingStatuses?.find(status => status.name === "Unknown");
            if (unknownDrinkingStatus) {
                this.state.lifestyle.drinkingStatus = unknownDrinkingStatus;
            }
        }
        if (!this.state.lifestyle.smokingStatus) {
            const unknownSmokingStatus = this.props.smokingStatuses?.find(status => status.name === "Unknown");
            if (unknownSmokingStatus) {
                this.state.lifestyle.smokingStatus = unknownSmokingStatus;
            }
        }
        if (!this.state.lifestyle.substanceAbuseStatus) {
            const unknownSubstanceAbuseStatus = this.props.substanceAbuseStatuses?.find(status => status.name === "Unknown");
            if (unknownSubstanceAbuseStatus) {
                this.state.lifestyle.substanceAbuseStatus = unknownSubstanceAbuseStatus;
            }
        }
    }
}

function mapStateToProps(state) {
    return {
        employmentStatuses: state.base.employmentStatuses,
        educationLevels: state.base.educationLevels,
        smokingStatuses: state.base.smokingStatuses,
        smokingDevices: state.base.smokingDevices,
        drinkingStatuses: state.base.drinkingStatuses,
        substanceAbuseStatuses: state.base.substanceAbuseStatuses,
        substanceAbuseTypes: state.base.substanceAbuseTypes
    };
}

export default connect(mapStateToProps)(LifestyleModal);
